const previewPage = {
  en: {
    previewPage: {
      title: 'Visit Preview',
      backToVisits: 'Back',
      checkSettingsTitle: 'Check your settings',
      checkSettingsSubtitle:
        'Please be sure to allow the app to use your mic and camera for the call. Change your settings below.',
      checkSettingsReminder: 'Reminder: This visit will be recorded for quality improvement purposes.',
      patientNameLabel: 'Patient Name',
      deviceSettingsTitle: 'Device settings',
      video: 'Video:',
      videoOff: 'Video off',
      microphone: 'Microphone:',
      speakers: 'Speakers:',
      joinBtn: 'Join',
    },
  },
}
export default previewPage
